module.exports = __webpack_public_path__ + "assets/img/driver-btn-82d5fbe9.png";